import React from 'react';
import logoITSP from '../../assets/img/ITSP.png';
import { Objetive } from './Components/Objetive';
import { CardToInstitutes } from "./Components/CardToInstitutes";
import { CardQuote } from '../../components/CardQuote';
import { Flow } from '../../workflows/Flow';
import { nodes, edges } from './matterFlow';

export function SaintPaulThelogicalnstitute() {
  return (
    <div className="container-fluid bg-light min-vh-100 pb-5">
      {/* --- Encabezado y Logo --- */}
      <header className="container py-5 text-center">
        <div className="mb-4">
          <img 
            src={logoITSP} 
            alt='Logo ITSP' 
            style={{ maxWidth: '180px', filter: 'drop-shadow(0px 4px 8px rgba(0,0,0,0.1))' }} 
          />
        </div>
        <h1 className="display-4 fw-bold text-uppercase text-primary mb-3">
          Instituto Teológico San Pablo
        </h1>
        <hr className="w-25 mx-auto border-primary border-2 opacity-75" />
      </header>

      <main className="container">
        {/* --- Sección: Quiénes Somos y Objetivo --- */}
        <section className="row g-4 align-items-center mb-5">
          <div className="col-lg-6">
            <div className="bg-white p-4 rounded-4 shadow-sm h-100">
              <h3 className="text-primary fw-bold mb-3 border-start border-4 border-primary ps-3">
                ¿Quiénes somos?
              </h3>
              <p className="lead text-secondary">
                El Instituto Teológico San Pablo es la institución educativa por excelencia de la <strong>ICIAR</strong>, 
                dedicada a la excelencia académica y espiritual.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="bg-primary text-white p-4 rounded-4 shadow-sm h-100 d-flex align-items-center">
              <Objetive objetive_info={'Nuestro objetivo es coadyuvar a la formación de pastores y ministras conforme al corazón de Dios.'}/>
            </div>
          </div>
        </section>

        {/* --- Sección: Visión, Misión y Compromiso --- */}
        <section className="row g-4 mb-5">
          <div className="col-md-4">
            <CardToInstitutes 
              title={'Visión'} 
              info={"México y las Naciones para Cristo."}
            />
          </div>
          <div className="col-md-4">
            <CardToInstitutes 
              title={'Misión'} 
              info={"Formar pastores y ministras conforme al corazón de DIOS, con amor profundo a su ministerio, sujeción y responsabilidad al llamado."}
            />
          </div>
          <div className="col-md-4">
            <CardToInstitutes 
              title={'Compromiso'} 
              info={"Que cada congregación sea atendida por un pastor o ministra que apaciente con ciencia e inteligencia."}
            />
          </div>
        </section>

        {/* --- Acordeón de Labor --- */}
        <section className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div className="accordion accordion-flush rounded-4 shadow-sm overflow-hidden" id="laborAccordion">
              <div className='accordion-item'>
                <h2 className="accordion-header">
                  <button className="accordion-button fw-bold text-primary bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLabor">
                    Nuestra labor fundamental consiste en:
                  </button>
                </h2>
                <div id="collapseLabor" className="accordion-collapse collapse show" data-bs-parent="#laborAccordion">
                  <div className="accordion-body bg-white">
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item border-0"><i className="bi bi-check2-circle text-primary me-2"></i>Atender la creciente demanda de líderes idóneos para la realidad actual.</li>
                      <li className="list-group-item border-0"><i className="bi bi-check2-circle text-primary me-2"></i>Asegurar que cada egresado tenga los rasgos fundamentales que Jesucristo requiere.</li>
                      <li className="list-group-item border-0"><i className="bi bi-check2-circle text-primary me-2"></i>Fomentar un pastorado con ciencia y entendimiento.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --- Sección de Llamado (Hero Card) --- */}
        <section className="mb-5">
          <div className="card border-0 rounded-5 overflow-hidden shadow-lg position-relative text-white">
            {/* Overlay Gradient */}
            <div style={{
              background: 'linear-gradient(45deg, rgba(13, 110, 253, 0.9), rgba(13, 202, 240, 0.8))',
              position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1
            }}></div>
            
            <div className="card-body p-5 text-center position-relative" style={{ zIndex: 2 }}>
              <h3 className="display-6 fw-bold mb-3">¿Has sentido el llamado de Dios?</h3>
              <p className="lead mb-4 mx-auto" style={{ maxWidth: '700px' }}>
                "Y les daré pastores conforme a mi propio corazón, que los guiarán con conocimiento y entendimiento."
              </p>
              <span className="badge bg-white text-primary px-3 py-2 fs-6 shadow-sm">Jeremías 3:15 NTV</span>
            </div>
          </div>
        </section>

        {/* --- Testimoniales --- */}
        <section className="mb-5">
          <h3 className='text-center text-uppercase fw-bold mb-4 text-primary'>Voces de nuestra comunidad</h3>
          <div className='row g-4'>
            {/* Testimonio 1: Formación */}
            <div className='col-md-4'>
              <CardQuote 
                person={"Hno. Ricardo Méndez"} 
                text="El instituto no solo transformó mi mente con teología, sino mi corazón con disciplina. Aprendí que un buen pastor primero debe ser un buen discípulo." 
              />
            </div>
            
            {/* Testimonio 2: Herramientas */}
            <div className='col-md-4'>
              <CardQuote 
                person={"Hna. Abigail Flores"} 
                text="Encontré las herramientas necesarias para trabajar con la niñez y la juventud de mi iglesia. La capacitación es profunda y totalmente aplicable a nuestra realidad." 
              />
            </div>

            {/* Testimonio 3: Gratitud */}
            <div className='col-md-4'>
              <CardQuote 
                person={"Obrero Samuel Soto"} 
                text="Agradezco a Dios por la paciencia de los maestros. Su experiencia en el campo ministerial es el valor más grande que nos transmiten en cada clase." 
              />
            </div>
          </div>
        </section>

        {/* --- Flujo de Materias --- */}
        <section className="row mb-5">
          <div className="col-12 bg-white p-4 rounded-4 shadow-sm">
            <h2 className='h3 text-center fw-bold mb-4 text-primary text-uppercase'>Mapa Curricular</h2>
            <div className="border rounded-3" style={{ background: '#f8f9fa' }}>
              <Flow 
                initialEdge={edges}
                initialNode={nodes}
                styleFlow={{ height: '35rem' }}
                disablePanOnDrag={false}
                disableZoomOnScroll={false} 
                disablePanOnScroll={true}
              />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}